<template>
    <div v-if="showDate" class="error">
        *{{ job }} will be automatically
        <b>Complete</b>
        if assigned to a team member.
    </div>
</template>
<script>
import moment from 'moment';

export default {
    name: 'TripDateInPast',
    props: {
        tripDate: {
            type: [Date, String],
            default: () => null,
            required: true
        },
        job: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            showDate: false
        };
    },
    watch: {
        tripDate(newValue, oldValue) {
            this.tripDateInThePast(true);
        }
    },
    async mounted() {
        this.tripDateInThePast(false);
    },
    methods: {
        tripDateInThePast(showPopup) {
            if (this.tripDate) {
                this.showDate = moment(this.tripDate, 'YYYY-MM-DD').isBefore(moment().startOf('day'));

                if (this.showDate && showPopup) {
                    this.$notify({
                        message: `${this.job} will be automatically <b>Complete</b> if assigned to a team member.`,
                        type: 'warning',
                        duration: 5000,
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    });
                }

                return;
            }

            this.showDate = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.error {
    font-size: 12px;
    margin-top: 5px !important;
    display: ruby-text !important;
    color: black !important;
}
</style>
